export const state = {
  actionSteps: [],
  isLoading: false,
  totalRecords: 0,
  actionStepPerPage: 10000,
  activePage: 1
}
